import React from 'react'
import Logo from "../../assets/images/Pixl Demo Application-Gif.gif"
import HeaderSection from '../../Components/HeaderSection'

function ExtractingLoader({ setisToggled, headerName, isToggled }) {
  return (
    <>
      <div className="px-3 flex-fill">
        <HeaderSection handleToggleBtn={() => setisToggled(!isToggled)} headerName={headerName} />
        {/* <Uploadfiles /> */}
        {/* <ExtractingLoader/> */}
      <div className='upload_section overflow-auto scrollbar1'>
        <div className='align-items-center py-md-0 py-4 d-block d-md-flex h-100 justify-content-center m-auto'>          <div className={`text-center d-none`}>
            <h2 className="font_22 text_master2 fw-bold mb-3 text-capitalize">{headerName}</h2>
          </div>
          <div className='h-100 d-flex justify-content-center align-items-center'>
            <img src={Logo} />
          </div>
        </div>
        </div>
      </div>
    </>
  )
}

export default ExtractingLoader